import AWSLocation, {
  SearchPlaceIndexForSuggestionsRequest,
} from 'aws-sdk/clients/location';

import { LOCATION_PLACE_INDEX } from './constants';

export type LatLong = { lat: number; long: number };

// Implementation of https://docs.aws.amazon.com/location/latest/developerguide/search-place-index-autocomplete.html
export async function suggestPois(term: string, bias?: LatLong) {
  return _suggestPois(term, new AWSLocation(), bias);
}

export async function _suggestPois(
  term: string,
  location: AWSLocation,
  bias?: LatLong
) {
  const suggestionParams: SearchPlaceIndexForSuggestionsRequest = {
    IndexName: LOCATION_PLACE_INDEX,
    Text: term,
    MaxResults: 15,
    // https://www.iso.org/iso-3166-country-codes.html
    FilterCountries: ['USA'],
  };

  if (bias) {
    suggestionParams.BiasPosition = [bias.long, bias.lat];
  }

  const results = await location
    .searchPlaceIndexForSuggestions(suggestionParams)
    .promise();

  return results.Results.filter((result) => {
    return !!result.PlaceId;
  });
}
